module.exports = __webpack_public_path__ + "static/media/stocking.5b6503ec.svg";